import React from 'react'

import  { useNavigate } from 'react-router-dom'

import './PageNotFound.css'
// import { BsEmojiFrown } from "react-icons/Bs"

function PageNotFound() {

  let navigate = useNavigate()


  return (
    <div className='pageNotFound'>
      <div className='pnf_container'>
        <div className='pnf_top'>
          404
        </div>
        <div className='pnf_bottom'>
          <div className='pnf_bottom1'>
            <p>Looks like the page is missing </p>
          </div>
          <div className='pnf_bottom2'>
            Meanwhile why don’t you try again by going 
          </div>
          <button className='pnf_btn' onClick={() => navigate('/')}>Back Home</button>
        </div>        
      </div>
    </div>
  )
}

export default PageNotFound